export default __webpack_public_path__ + "static/media/category6.0648a796.png";